import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [],
  isLoading: false,
  error: null,
  success: null,
};

const plantDigitalTwinSlice = createSlice({
  name: "plantDigitalTwin",
  initialState,
  reducers: {
    fetchPlantDigitalTwinStart(state) {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    },
    fetchPlantDigitalTwinSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    fetchPlantDigitalTwinFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
  },
});

export const { fetchPlantDigitalTwinStart, fetchPlantDigitalTwinSuccess, fetchPlantDigitalTwinFailure } =
  plantDigitalTwinSlice.actions;
export default plantDigitalTwinSlice.reducer;
